import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ColumnMappingPanel from './ColumnMappingPanel';
import { getFileMappingInfo } from 'redux/files/FilesActions';
import { resetImportMappingData, backupMappedFields, restoreMappedFields } from 'redux/mapping/MappingActions';
import { addMappedFieldsToProfile } from 'redux/profiles/ProfilesActions';
import { disableMappedTargetFields } from 'redux/targetFields/TargetFieldsActions';
import {
  backupTranslationTables,
  restoreTranslationTables
} from 'redux/profileTranslationTables/ProfileTranslationTablesActions';

const mapStateToProps = ({ files, profiles, targetFields, mapping }) => {
  const mappedRequiredFields = mapping.mappedFields.filter(
    mappedField => targetFields.requiredFields.find(
      requiredField => ( requiredField.name === mappedField.targetField ) 
    )
  );
  return {
    columnDelimiter: profiles.profile.columnDelimiter,
    fileExtension: files.fileExtension,
    fileName: files.fileName,
    mappedFields: mapping.mappedFields,
    mappedFieldsCount: profiles.mappedFieldsCount,
    targetFields: targetFields.fields,
    fetchingTargetFields: targetFields.fetchingTargetFields,
    fetchingProfile: profiles.fetchingProfile,
    remainingRequiredFieldsCount: (targetFields.requiredFields.length - mappedRequiredFields.length)
  };
};

const mapDispatchToProps = dispatch => ({
  filesActions: bindActionCreators({ getFileMappingInfo }, dispatch),
  mappingActions: bindActionCreators({ resetImportMappingData, backupMappedFields, restoreMappedFields }, dispatch),
  profileActions: bindActionCreators({ addMappedFieldsToProfile }, dispatch),
  targetFieldsActions: bindActionCreators({ disableMappedTargetFields }, dispatch),
  profileTTActions: bindActionCreators({ backupTranslationTables, restoreTranslationTables }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ColumnMappingPanel);



// WEBPACK FOOTER //
// ./src/components/importProfile/comp/columnMappingPanel/ColumnMappingPanelConnector.js